// PercentStackedBarChart.js
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartjsPluginStacked100 from 'chartjs-plugin-stacked100';
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartjsPluginStacked100);
 
 
const StackedSingleBarChart = ({ promoters, passives, detractors }) => {
  const [promotersCount, setPromotersCount] = useState(0);
  const [passivesCount, setPassivesCount] = useState(0);
  const [detractorsCount, setDetractorsCount] = useState(0);
 
  useEffect(() => {
    setPromotersCount(promoters);
    setPassivesCount(passives);
    setDetractorsCount(detractors);
  }, [promoters, passives, detractors]);
 
  // custom tooltip
  const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');
 
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.classList.add('customChartJsToolTop');
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.backgroundColor = 'white';
      tooltipEl.style.border = '1px solid #ccc';
      tooltipEl.style.borderRadius = '3px';
      tooltipEl.style.padding = '5px';
      tooltipEl.style.boxShadow = '0px 0px 6px rgba(0, 0, 0, 0.2)';
 
      const table = document.createElement('table');
      table.style.margin = '0px';
      tooltipEl.appendChild(table);
      chart.canvas.parentNode.appendChild(tooltipEl);
    }
 
    return tooltipEl;
  };
  const externalTooltipHandler = (context) => {
    // Tooltip Element
    const { chart, tooltip } = context;
    const tooltipEl = getOrCreateTooltip(chart);
 
    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }
 
    // Set Text
    if (tooltip.body) {
      const titleLines = tooltip.title || [];
      const bodyLines = tooltip.body.map(b => b.lines);
 
      const tableHead = document.createElement('thead');
 
      titleLines.forEach(title => {
        const tr = document.createElement('tr');
        const th = document.createElement('th');
        th.textContent = title;
        th.style.borderWidth = 0;
        tr.appendChild(th);
        tableHead.appendChild(tr);
      });
 
      const tableBody = document.createElement('tbody');
      bodyLines.forEach((body, i) => {
        const colors = tooltip.labelColors[i];
 
        const span = document.createElement('span');
        span.style.background = colors.backgroundColor;
        span.style.borderColor = colors.borderColor;
        span.style.borderWidth = '2px';
        span.style.marginRight = '10px';
        span.style.height = '10px';
        span.style.width = '10px';
        span.style.display = 'inline-block';
        span.style.zIndex = '99';
 
        const tr = document.createElement('tr');
        const td = document.createElement('td');
        td.style.borderWidth = 0;
        td.appendChild(span);
 
        td.appendChild(document.createTextNode(body));
        tr.appendChild(td);
        tableBody.appendChild(tr);
      });
 
      const tableRoot = tooltipEl.querySelector('table');
      while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
      }
      tableRoot.appendChild(tableHead);
      tableRoot.appendChild(tableBody);
    }
 
   
    const canvas = chart.canvas;
    canvas.addEventListener('mousemove', (event) => {
      const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
      const mouseX = event.clientX - positionX;  
      const mouseY = event.clientY - positionY;
      tooltipEl.style.opacity = 1;
     // tooltipEl.style.left = `${mouseX + tooltip.caretX}px`;
      tooltipEl.style.left = `${mouseX }px`;
     // tooltipEl.style.top = `${mouseY - tooltip.caretY}px`;  
      tooltipEl.style.font = tooltip.options.bodyFont.string;
      tooltipEl.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
      tooltipEl.style.width = 'auto';
      tooltipEl.style.zIndex = '9';
      tooltipEl.style.color = '#000';
    });
 
  };
 
 
  // Data configuration
  const data = {
    labels: [''],
    datasets: [
      { label: 'Promoters', data: [promotersCount], backgroundColor: '#008000', },
      { label: 'Passives', data: [passivesCount], backgroundColor: '#ffb62f', },
      { label: "Detractors", data: [detractorsCount], backgroundColor: '#f10000', },
    ],
  };
 
  // Options configuration
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allows the chart to fill its container
    indexAxis: 'y', // Set the axis to y for horizontal bars
    plugins: {
      stacked100: {
        enable: true
      },
      title: {
        display: false, // Hides the chart title
      },
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        position: 'average',
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
          },
        },
        external: externalTooltipHandler,
      },
    },
    layout: {
      padding: {
        bottom: 0, // Remove extra space below the chart
      },
    },
    scales: {
      x: {
        display: false,
        stacked: true,
        beginAtZero: true,
        grid: {
          display: false,
        },
        title: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          padding: 0,
          display: false,
        },
      },
      y: {
        display: false,
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    barThickness: 8,
  };
 
 
 
 
 
  return (
    // <div style={{ height: '10px', width: '200px', margin: '0 auto', position: 'relative' }}>
    <Bar data={data} options={options} />
    // </div>
  );
};
 
 
 
export const StackedSingleBarChart1 = ({ chartData, colors }) => {
 
  // Create and style custom tooltip
  const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');
 
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.classList.add('customChartJsToolTop');
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.backgroundColor = 'white';
      tooltipEl.style.border = '1px solid #ccc';
      tooltipEl.style.borderRadius = '3px';
      tooltipEl.style.padding = '5px';
      tooltipEl.style.boxShadow = '0px 0px 6px rgba(248, 248, 248, 0.97)';
 
      const table = document.createElement('table');
      table.style.margin = '0px';
      tooltipEl.appendChild(table);
      chart.canvas.parentNode.appendChild(tooltipEl);
    }
 
    return tooltipEl;
  };
 
  const externalTooltipHandler = (context) => {
    const { chart, tooltip } = context;
    const tooltipEl = getOrCreateTooltip(chart);
 
    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }
 
    // Set Text
    if (tooltip.body) {
      const titleLines = tooltip.title || [];
      const bodyLines = tooltip.body.map(b => b.lines);
 
      const tableHead = document.createElement('thead');
      titleLines.forEach(title => {
        const tr = document.createElement('tr');
        const th = document.createElement('th');
        th.textContent = title;
        th.style.borderWidth = 0;
        tr.appendChild(th);
        tableHead.appendChild(tr);
      });
 
      const tableBody = document.createElement('tbody');
      bodyLines.forEach((body, i) => {
        const colors = tooltip.labelColors[i];
        const span = document.createElement('span');
        span.style.background = colors.backgroundColor;
        // span.style.background = '#000';
        span.style.borderColor = colors.borderColor;
        // span.style.color = '#333';
        span.style.borderWidth = '2px';
        span.style.marginRight = '10px';
        span.style.height = '10px';
        span.style.width = '10px';
        span.style.display = 'inline-block';
        span.style.zIndex = '99';
 
        const tr = document.createElement('tr');
        const td = document.createElement('td');
        td.style.borderWidth = 0;
        td.appendChild(span);
        td.appendChild(document.createTextNode(body));
        tr.appendChild(td);
        tableBody.appendChild(tr);
      });
 
      const tableRoot = tooltipEl.querySelector('table');
      while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
      }
      tableRoot.appendChild(tableHead);
      tableRoot.appendChild(tableBody);
    }
 
    // const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
    // tooltipEl.style.opacity = 1;
    // tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
    // tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
    // tooltipEl.style.font = tooltip.options.bodyFont.string;
    // tooltipEl.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
    // tooltipEl.style.width = 'auto';
    // tooltipEl.style.zIndex = '9';
    // tooltipEl.style.color = '#000';

    const canvas = chart.canvas;
    canvas.addEventListener('mousemove', (event) => {
      const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
      const mouseX = event.clientX - positionX;  
      const mouseY = event.clientY - positionY;
      tooltipEl.style.opacity = 1;
     // tooltipEl.style.left = `${mouseX + tooltip.caretX}px`;
      tooltipEl.style.left = `${mouseX }px`;
     // tooltipEl.style.top = `${mouseY - tooltip.caretY}px`;  
      tooltipEl.style.font = tooltip.options.bodyFont.string;
      tooltipEl.style.padding = `${tooltip.options.padding}px ${tooltip.options.padding}px`;
      tooltipEl.style.width = 'auto';
      tooltipEl.style.zIndex = '9';
      tooltipEl.style.color = '#000';
    });
  };
 
  // Use the colors array to set dataset colors
  const datasets = chartData.datasets.map((dataset, index) => ({
    ...dataset,
    backgroundColor: colors[index] || '#000000' // Default to black if color is not provided
  }));
  // Data configuration
  const data = {
    ...chartData,
    datasets
  };
 
 
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      stacked100: { enable: true },
      title: { display: false },
      datalabels: { display: false },
      legend: { display: false },
      tooltip: {
        enabled: false,
        position: 'average',
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
          },
        },
        external: externalTooltipHandler,
      },
    },
    layout: {
      padding: {
        bottom: 0,
      },
    },
    scales: {
      x: {
        display: false,
        stacked: true,
        beginAtZero: true,
        grid: { display: false },
        title: { display: false },
        ticks: { display: false },
      },
      y: {
        display: false,
        stacked: true,
        grid: { display: false },
        ticks: { display: false },
      },
    },
    barThickness: 18,
  };
 
 
  return <Bar data={data} options={chartOptions} />;
};
 
export default StackedSingleBarChart;
 
 